import { type HeroIconName, HeroIconNames } from '../hero/types/names.ts'
import { type SvgIconName, SvgIconNames } from '../svg/types/names.ts'

export type IconName = HeroIconName | SvgIconName
export const IconNames = [...HeroIconNames, ...SvgIconNames]
